module.exports = __webpack_public_path__ + "static/rawpixel-701117-unsplash-f01a619dc2519e2978867f22cd77fef5.jpg";